var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Bluebird from "bluebird";
import socketService from "./socket.service";
var keyStore = require("../crypto/keyStore.js");
import Observer from "../asset/observer";
var initService = require("services/initService");
import sessionService from "../services/session.service";
import MutableObjectLoader, { UpdateEvent } from "../services/mutableObjectLoader";
import SecuredDataApi, { SecuredData } from "../asset/securedDataWithMetaData";
import h from "../helper/helper";
import { isBusinessVersion } from "../services/location.manager";
var EncryptedData = require("crypto/encryptedData");
var RELOAD_DELAY = 10000;
var notVisible = {
    encrypt: true,
    visibility: []
};
var privacyAttributes = ["birthday", "location", "relationship", "education", "work", "gender", "languages"];
var publicBranches = ["uiLanguage", "sound", "donate", "safety"];
var serverBranches = ["mailsEnabled", "friendsAccess"];
var defaultSettings = {
    privacy: {
        basic: {
            firstname: {
                encrypt: false,
                visibility: ["always:allfriends"]
            },
            lastname: {
                encrypt: false,
                visibility: ["always:allfriends"]
            }
        },
        imageBlob: {
            encrypt: false,
            visibility: []
        },
        location: notVisible,
        birthday: notVisible,
        relationship: notVisible,
        education: notVisible,
        work: notVisible,
        gender: notVisible,
        languages: notVisible
    },
    donate: {
        refused: false,
        later: 0
    },
    sharePosts: ["always:allfriends"],
    filterSelection: [],
    sound: {
        enabled: true
    },
    messages: {
        sendShortCut: "enter"
    },
    safety: {
        blockedUsers: []
    },
    uiLanguage: "en",
    friendsAccess: !isBusinessVersion()
};
var isBranchPublic = function (branchName) {
    return publicBranches.indexOf(branchName) > -1;
};
var isBranchServer = function (branchName) {
    return serverBranches.indexOf(branchName) > -1;
};
var securedDataOptions = { type: "settings", removeEmpty: true };
var turnOldSettingsToNew = function (settings) {
    var result = {
        meta: { initialLanguage: undefined },
        content: {}
    };
    h.objectEach(settings, function (key, val) {
        if (isBranchPublic(key)) {
            result.meta[key] = val;
        }
        else {
            result.content[key] = val;
        }
    });
    return result;
};
var migrate = function (givenSettings) {
    console.warn("migrating settings to format 2");
    if (!givenSettings.ct) {
        return Bluebird.resolve(new SecuredData(givenSettings.content, givenSettings.meta, securedDataOptions, false));
    }
    return Bluebird.try(function () {
        keyStore.security.allowPrivateActions();
        var oldSettings = new EncryptedData(givenSettings);
        return oldSettings.decrypt();
    }).then(function (decryptedSettings) {
        var _a = turnOldSettingsToNew(decryptedSettings), meta = _a.meta, content = _a.content;
        meta.initialLanguage = h.getLanguageFromPath();
        var ownUser = require("users/userService").default.getOwn();
        var transformedSettings = new Settings(content, meta);
        return transformedSettings.getUpdatedData(ownUser.getSignKey(), ownUser.getMainKey());
    }).then(function (signedAndEncryptedSettings) {
        var settings = new SecuredData(signedAndEncryptedSettings.content, signedAndEncryptedSettings.meta, securedDataOptions, false);
        return socketService.emit("settings.setSettings", {
            settings: signedAndEncryptedSettings,
        }).thenReturn(settings);
    });
};
var Settings = /** @class */ (function () {
    function Settings(content, meta, server) {
        if (server === void 0) { server = {}; }
        var _this = this;
        this.content = content;
        this.meta = meta;
        this.server = server;
        this.changed = false;
        this.getContent = function () { return _this.content; };
        this.getMeta = function () { return _this.meta; };
        this.getServer = function () { return _this.server; };
        this.getBranch = function (branchName) {
            if (isBranchServer(branchName)) {
                return _this.server[branchName];
            }
            if (isBranchPublic(branchName)) {
                return _this.meta[branchName];
            }
            return _this.content[branchName];
        };
        this.isChanged = function () { return _this.changed; };
        this.setBranch = function (branchName, value) {
            if (isBranchServer(branchName)) {
                _this.server[branchName] = value;
            }
            else if (isBranchPublic(branchName)) {
                _this.meta[branchName] = value;
            }
            else {
                _this.content[branchName] = value;
            }
            _this.changed = true;
        };
        this.update = function (content, meta, server) {
            _this.content = content;
            _this.meta = meta;
            _this.server = server;
            _this.changed = false;
        };
        this.getUpdatedData = function (signKey, encryptKey) {
            return SecuredDataApi.createAsync(_this.content, _this.meta, securedDataOptions, signKey, encryptKey)
                .then(function (encryptedSettings) {
                return __assign({}, encryptedSettings, { server: _this.server });
            });
        };
    }
    return Settings;
}());
var loadSettings = function (givenSettings) {
    return Bluebird.try(function () {
        return __awaiter(this, void 0, void 0, function () {
            var secured, ownUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, migrate(givenSettings)];
                    case 1:
                        secured = _a.sent();
                        return [4 /*yield*/, require("users/userService").default.getOwnAsync()];
                    case 2:
                        ownUser = _a.sent();
                        return [4 /*yield*/, Bluebird.all([
                                secured.decrypt(),
                                secured.verifyAsync(ownUser.getSignKey(), "settings")
                            ])];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, {
                                content: secured.contentGet(),
                                meta: secured.metaGet(),
                                server: givenSettings.server
                            }];
                }
            });
        });
    });
};
var settings;
var SettingsService = /** @class */ (function (_super) {
    __extends(SettingsService, _super);
    function SettingsService() {
        var _this = _super.call(this) || this;
        _this.setDefaultLanguage = function (language) { return defaultSettings.uiLanguage = language; };
        _this.getContent = function () { return settings.getContent(); };
        _this.getBranchContent = function (branchName) { return settings.getBranch(branchName); };
        _this.getBranch = function (branchName) {
            if (!settings) {
                return defaultSettings[branchName];
            }
            var branchContent = _this.getBranchContent(branchName);
            if (typeof branchContent === "undefined") {
                return defaultSettings[branchName];
            }
            return branchContent;
        };
        _this.updateBranch = function (branchName, value) {
            settings.setBranch(branchName, value);
            _this.notify("", "updated");
        };
        _this.setPrivacy = function (privacy) {
            return Bluebird.try(function () {
                _this.updateBranch("privacy", privacy);
                return _this.uploadChangedData();
            }).then(function () {
                var userService = require("users/userService").default;
                return userService.getOwn().uploadChangedProfile();
            });
        };
        _this.removeCircle = function (id) {
            return Bluebird.try(function () {
                var privacy = _this.getBranch("privacy");
                privacyAttributes.forEach(function (safetyName) {
                    h.removeArray(privacy[safetyName].visibility, "circle:" + id);
                });
                h.removeArray(privacy.basic.firstname.visibility, "circle:" + id);
                h.removeArray(privacy.basic.lastname.visibility, "circle:" + id);
                return _this.setPrivacy(privacy);
            });
        };
        _this.uploadChangedData = function () {
            if (!settings.isChanged()) {
                return Bluebird.resolve(true);
            }
            var userService = require("users/userService").default;
            var ownUser = userService.getOwn();
            return settings.getUpdatedData(ownUser.getSignKey(), ownUser.getMainKey())
                .then(function (settings) { return socketService.emit("settings.setSettings", { settings: settings }); })
                .then(function (result) { return result.success; });
        };
        _this.getBlockedUsers = function () { return _this.getBranch("safety").blockedUsers; };
        _this.setBlockedUsers = function (blockedUsers) {
            var safety = _this.getBranch("safety");
            _this.updateBranch("safety", __assign({}, safety, { blockedUsers: blockedUsers }));
            return _this.uploadChangedData();
        };
        _this.isBlockedSince = function (userID, time) {
            return !!_this.getBlockedUsers().find(function (_a) {
                var id = _a.id, since = _a.since;
                return userID === id && since < time;
            });
        };
        _this.isBlocked = function (userID) {
            return !!_this.getBlockedUsers().find(function (_a) {
                var id = _a.id;
                return userID === id;
            });
        };
        _this.getPrivacyAttribute = function (attr) {
            var b = _this.getBranch("privacy"), i, attrs = attr.split("."), cur = b;
            for (i = 0; i < attrs.length; i += 1) {
                if (cur[attrs[i]]) {
                    if (typeof cur[attrs[i]].encrypt !== "undefined") {
                        return cur[attrs[i]];
                    }
                    cur = cur[attrs[i]];
                }
            }
            throw new Error("could not find attribute settings");
        };
        _this.getPrivacyEncryptionStatus = function (attr) {
            return _this.getPrivacyAttribute(attr).encrypt;
        };
        _this.getPrivacyVisibility = function (attr) {
            var privacyAttribute = _this.getPrivacyAttribute(attr);
            if (privacyAttribute.encrypt) {
                return privacyAttribute.visibility;
            }
            else {
                return false;
            }
        };
        return _this;
    }
    return SettingsService;
}(Observer));
;
export default new SettingsService();
var SettingsLoader = /** @class */ (function (_super) {
    __extends(SettingsLoader, _super);
    function SettingsLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SettingsLoader;
}(MutableObjectLoader({
    download: function (_id, previousInstance) {
        return socketService.awaitConnection()
            .then(function () { return socketService.definitlyEmit("settings.get", {
            responseKey: "content",
            cacheSignature: previousInstance && previousInstance.getMeta()._signature
        }); })
            .then(function (response) { return response.content; });
    },
    load: function (response, previousInstance) {
        if (previousInstance && response.unChanged) {
            return Bluebird.resolve({
                content: previousInstance.getContent(),
                meta: previousInstance.getMeta(),
                server: response.content.server
            });
        }
        return loadSettings(response.content);
    },
    restore: function (_a, previousInstance) {
        var content = _a.content, meta = _a.meta, server = _a.server;
        if (previousInstance) {
            previousInstance.update(content, meta, server);
            return previousInstance;
        }
        return new Settings(content, meta, server);
    },
    shouldUpdate: function (event) {
        if (event === UpdateEvent.wake) {
            return Bluebird.delay(RELOAD_DELAY).thenReturn(true);
        }
        return Bluebird.resolve(false);
    },
    getID: function () { return sessionService.getUserID(); },
    cacheName: "settings"
})));
initService.registerCallback(function () {
    return SettingsLoader.get(sessionService.getUserID())
        .then(function (loadedSettings) { return settings = loadedSettings; });
});



//////////////////
// WEBPACK FOOTER
// ./js/services/settings.service.ts
// module id = Etis
// module chunks = 1 2 3